/** @format */

import React from 'react';
import Card from 'react-bootstrap/Card';
import { EqualHeightElement } from 'react-equal-height';
import getPropertyTypeTranslation from 'utils/getPropertyTypeTranslation';
import { PropertyTypes } from 'utils/propertyObjectHelper';
import { buildAddress } from 'utils/addressHelper';
import BlankImage from 'assets/images/images/no-object-image.png';
import { displayAsPrice } from 'utils/format';

import './styles.scss';

export default function SearchImageCard(props) {
  const {
    type,
    //price, not used anymore
    startingPrice,
    finalPrice,
    location,
    // bedrooms,
    // bathrooms,
    // dimensions,
    currency,
    // status,
    imageUrl,
    onComplete,
    isMobile,
    translation,
    // countryCode,
    noOfRooms,
    monthlyFee,
    address,
    brokerData,
    extra,
    bidSetting,
    areaSize,
    buildingSize
  } = props;

  const PropertySummarySection = () => {
    const PropertyInfo = ({ value = null, text = '', className = false }) => (
      <span className={`icon-strip-text ${className ? className : ''}`}>
        {value ? value : 'N/A'}
        <span className='label-text'>{text}</span>
      </span>
    );

    if ([PropertyTypes.HousingCooperative].includes(type)) {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container three-items'>
            <PropertyInfo
              value={noOfRooms}
              text='rum'
              className='no-of-rooms'
            />
            <PropertyInfo value={monthlyFee} text='kr/mån' />

            <PropertyInfo
              value={buildingSize}
              text='kvm boarea'
              className='area-size'
            />
          </div>
        </div>
      );
    } else if (
      [PropertyTypes.House, PropertyTypes.Condominium].includes(type)
    ) {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container two-items'>
            <PropertyInfo
              value={noOfRooms}
              text='rum'
              className='no-of-rooms'
            />

            <PropertyInfo value={areaSize} text='kvm tomt' />

            <PropertyInfo
              value={buildingSize}
              text='kvm boarea'
              className='area-size'
            />
          </div>
        </div>
      );
    } else if (
      [PropertyTypes.Plot, PropertyTypes.CommercialProperty].includes(type)
    ) {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container two-items'>
            <PropertyInfo
              value={buildingSize}
              text='kvm boarea'
              className='area-size'
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className='listing-type  text2r'>
          <div className='icon-strip-container three-items'>
            <PropertyInfo
              value={noOfRooms}
              text='rum'
              className='no-of-bed-rooms'
            />
            <PropertyInfo value={areaSize} text='kvm tomt' />

            <PropertyInfo
              value={buildingSize}
              text='kvm boarea'
              className='area-size'
            />
          </div>
        </div>
      );
    }
  };

  const AddressSection = () => {
    const builtAddress = buildAddress({
      streetAddress: address.streetAddress,
      municipality: address?.municipality,
      city: address?.city,
      estateType: type,
      objectAddressObj: address
    });

    if (builtAddress) {
      return (
        <span className='listing-type address text2r'>{builtAddress}</span>
      );
    }

    return (
      <span
        style={{
          display: 'block',
          height: '20px'
        }}
      />
    );
  };

  const BrokerInfo = () => {
    const { firstName, lastName, picture } = brokerData;

    return (
      <div className='search-object-broker-info'>
        <img src={picture} className='broker-profile-pic' />
        <div className='broker-name'>
          <span className='text2r'>{firstName}</span>

          <span className='text2r'>{lastName}</span>
        </div>
      </div>
    );
  };

  const PriceSection = () => {
    const getDisplayPrice = () => {
      if (finalPrice > 0) {
        return finalPrice;
      } else {
        return startingPrice;
      }
    };

    const displayPrice = displayAsPrice(getDisplayPrice());

    const displayCurrency = (() => {
      const { currency: currencyName } = extra?.price || {};
      if (currencyName && currencyName !== 'SEK') {
        return currencyName;
      } else {
        return currency;
      }
    })();

    return (
      <h3 className='listing-price'>{displayPrice + ' ' + displayCurrency}</h3>
    );
  };

  const ObjectStatusIndicator = () => {
    if (extra?.status?.id === '10' || extra?.status?.id === '4') {
      return (
        <p className='listing-box-sold-tag text3m'>
          {translation?.property_status?.sold?.text}
        </p>
      );
    } else if (extra?.status?.id === '11' || extra?.advertise?.showAsComming) {
      return (
        <p className='listing-box-upcoming-tag text3m'>
          {translation?.property_status?.upcoming?.text}
        </p>
      );
    } else if (bidSetting === 'ShowBidding') {
      return (
        <p className='listing-box-bidding-in-progress-tag text3m'>
          Budgivning pågår
        </p>
      );
    } else {
      return <></>;
    }
  };

  return (
    <Card className='listing-box'>
      {!isMobile ? (
        <div className='listing-box-img-container'>
          <Card.Img
            variant='top'
            className='listing-box-img'
            onLoad={onComplete}
            src={imageUrl.length === 0 ? BlankImage : imageUrl}
          />

          <ObjectStatusIndicator />
        </div>
      ) : (
        <EqualHeightElement>
          <div className='listing-box-img-container'>
            <Card.Img
              variant='top'
              className='listing-box-img'
              onLoad={onComplete}
              src={imageUrl.length === 0 ? BlankImage : imageUrl}
            />

            <ObjectStatusIndicator />
          </div>
        </EqualHeightElement>
      )}

      <Card.Body>
        <div className='card-body-top-section'>
          <div className='object-base-info'>
            <div className='heading-flag-section'>
              <p className='listing-type  text2r'>
                {getPropertyTypeTranslation(type, translation?.propertyType)}
              </p>
            </div>
            <p className='listing-location '>
              {typeof location === 'string' && location !== ''
                ? location.length > 15
                  ? `${location.substring(0, 15)}...`
                  : location
                : '\u00A0'}
            </p>
            <AddressSection />
          </div>
          <BrokerInfo />
        </div>
        <PriceSection />

        <PropertySummarySection />
      </Card.Body>
    </Card>
  );
}
